module.exports = __webpack_public_path__ + "static/sfa-473c07c47cd8d679c1b589d545ea9033.png";